import React from "react";
import ContactUsForm from "../components/ContactUsForm";

function ContactUs() {
    return (
        <ContactUsForm />
    )
}
export default ContactUs;